export const EVENT_VIEW_TABS = {
  basicInfo: "basicInfo",
  /** Draft events in the admin portal only (PROLINE-4057). */
  crewSize: "crewSize",
  roles: "roles",
  zones: "zones",
  requirementsAndComments: "requirementsAndComments",
  applicants: "applicants",
  evaluations: "evaluations",
  timesheet: "timesheet",
  reports: "reports",
  clientReports: "clientReports",
  payroll: "payrolls",
  heatMap: "heatMap",
};

/** Query param for opening a report detail on the event view URL (`?tab=reports&report=`). */
export const EVENT_REPORT_URL_PARAM = "report";

export const EVENT_VIEW_DEFAULT_TAB = EVENT_VIEW_TABS.basicInfo;

/** Feature flag for the in-event Payroll tab (not a sidebar route). */
export const isEventPayrollTabEnabled = true;

const KNOWN_EVENT_VIEW_TABS = Object.values(EVENT_VIEW_TABS);

export const isKnownEventViewTab = (tab) => KNOWN_EVENT_VIEW_TABS.includes(tab);

/** Tab is present in the URL and currently allowed for this event. */
export const getEventViewTabFromSearch = (search, allowedValues) => {
  const tab = new URLSearchParams(search).get("tab");
  return allowedValues.includes(tab) ? tab : null;
};

/**
 * Prefer an allowed tab; if the URL has a known tab that is not yet allowed
 * (e.g. event still loading), keep it so refresh does not flash basicInfo.
 */
export const resolveEventViewTabFromSearch = (search, allowedValues) => {
  const tab = new URLSearchParams(search).get("tab");
  if (allowedValues.includes(tab)) return tab;
  if (isKnownEventViewTab(tab)) return tab;
  return null;
};

/** Supervisors only ever get Basic Info (view) + Evaluations — every other
 * event tab is hidden for them regardless of the event's applicants state. */
export const getAllowedEventViewTabs = (
  showApplicantsTab,
  showEvaluationsTab = showApplicantsTab,
  isSupervisor = false,
  showTimesheetTab = false,
  showReportsTab = false,
  showPayrollTab = false,
  showHeatMapTab = false,
  showClientReportsTab = false,
) => {
  if (isSupervisor) {
    return [EVENT_VIEW_TABS.basicInfo, EVENT_VIEW_TABS.evaluations];
  }

  const base = [
    EVENT_VIEW_TABS.basicInfo,
    EVENT_VIEW_TABS.roles,
    EVENT_VIEW_TABS.zones,
    EVENT_VIEW_TABS.requirementsAndComments,
  ];

  if (showApplicantsTab) {
    base.push(EVENT_VIEW_TABS.applicants);
  }

  if (showPayrollTab && isEventPayrollTabEnabled) {
    base.push(EVENT_VIEW_TABS.payroll);
  }

  if (showEvaluationsTab) {
    base.push(EVENT_VIEW_TABS.evaluations);
  }

  if (showTimesheetTab) {
    base.push(EVENT_VIEW_TABS.timesheet);
  }

  if (showReportsTab) {
    base.push(EVENT_VIEW_TABS.reports);
  }

  if (showHeatMapTab) {
    base.push(EVENT_VIEW_TABS.heatMap);
  }

  if (showClientReportsTab) {
    base.push(EVENT_VIEW_TABS.clientReports);
  }

  return base;
};

export const getEventViewTabLabels = (viewEventsMessages) => ({
  [EVENT_VIEW_TABS.basicInfo]: viewEventsMessages.basicInfo,
  [EVENT_VIEW_TABS.crewSize]: viewEventsMessages.crewSizeTab?.label,
  [EVENT_VIEW_TABS.roles]: viewEventsMessages.roles,
  [EVENT_VIEW_TABS.zones]: viewEventsMessages.zones,
  [EVENT_VIEW_TABS.requirementsAndComments]:
    viewEventsMessages.requirementsAndComments,
  [EVENT_VIEW_TABS.applicants]: viewEventsMessages.applicants,
  [EVENT_VIEW_TABS.evaluations]: viewEventsMessages.evaluations,
  [EVENT_VIEW_TABS.timesheet]: viewEventsMessages.timesheet,
  [EVENT_VIEW_TABS.reports]: viewEventsMessages.reports,
  [EVENT_VIEW_TABS.clientReports]: viewEventsMessages.clientReports,
  [EVENT_VIEW_TABS.payroll]: viewEventsMessages.payroll,
  [EVENT_VIEW_TABS.heatMap]: viewEventsMessages.heatMap,
});
